import axios from 'axios'
import authService from './auth.service'

const axiosInstance = axios.create({
  baseURL:
    window.location.hostname === 'codigos.oasistreaming.com'
      ? 'https://api.codigos.oasistreaming.com/api'
      : 'http://localhost:3000/api',
  timeout: 5000,
  withCredentials: true, // necesario para que el navegador guarde la cookie oasis_sso (SSO con oasistreaming)
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para añadir el token a las peticiones
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Interceptor para manejar errores
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado o inválido
      authService.logout()
      window.location.href = '/auth/login'
    }
    return Promise.reject(error)
  },
)

export default axiosInstance
